var map = {
	"./APYMSA 2020-.png": 9266,
	"./APYMSA_2020_bco_2.png": 8408,
	"./APYMSA_2020_bco_21.png": 704,
	"./AUTEX-09.png": 8124,
	"./AUTEX-10.png": 1888,
	"./American Express.png": 8011,
	"./Amex.png": 276,
	"./CajaIcono.svg": 2618,
	"./EscudoIcono.svg": 5638,
	"./Mastercard_b1.png": 4244,
	"./Mastercard_b1_back.png": 213,
	"./Mastercard_b2.png": 383,
	"./Mastercard_back.png": 3957,
	"./Visa3.png": 2621,
	"./Visa_back.png": 9745,
	"./autex_rojo.png": 9851,
	"./chip-tarjeta.png": 6366,
	"./descarga.png": 6017,
	"./llamadaicon.png": 9733,
	"./llamadaicon_back.png": 5093,
	"./mastercard.png": 3223,
	"./openpay - copia.png": 2503,
	"./openpay_back.png": 1588,
	"./openpay_color.png": 7163,
	"./openpay_color_back.png": 2141,
	"./secure_openpay.png": 6691,
	"./visa.png": 9904,
	"./visa2.png": 5982,
	"./whatsapp-icon.png": 2055,
	"./whatsapp-icon_back.png": 1385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;